const storage = {};

storage.set = (key, object) => {
  localStorage[key] = JSON.stringify(object);
};

storage.get = (key) => {
  if (!localStorage[key]) {
    return undefined;
  }
  return JSON.parse(localStorage[key]);
};

storage.haveToGet = (key) => {
  if (localStorage[key]) {
    return JSON.parse(localStorage[key]);
  }
  storage.clearLogout();
  window.location.href = '/';
  return null;
};

storage.remove = (key) => {
  if (localStorage[key]) {
    localStorage.removeItem(key);
  }
};

storage.clear = () => {
  localStorage.clear();
};

storage.clearLogout = () => {
  const idSave = localStorage.getItem('idSave');
  // const surveyDontView = localStorage.getItem('surveyDontView');
  const popupNoneDisplay = localStorage.getItem('popupNoneDisplay');
  localStorage.clear();
  localStorage.setItem('idSave', idSave);
  // localStorage.setItem('surveyDontView', surveyDontView);
  localStorage.setItem('popupNoneDisplay', popupNoneDisplay);
};

storage.sessionSet = (key, object) => {
  sessionStorage.setItem(key, JSON.stringify(object));
};

storage.sessionGet = (key) => {
  const item = sessionStorage.getItem(key);
  if (!item) {
    return undefined;
  }
  return JSON.parse(item);
};

storage.sessionRemove = (key) => {
  sessionStorage.removeItem(key);
};
storage.sessionClear = () => {
  sessionStorage.clear();
};
export default storage;
